export default {
  state: {
    color: ''
  },
  getter: {
    color: state => {
      return state.color
    }
  },
  mutations: {
    color(state, color) {
      state.color = color;
    }
  },
  action: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/color.js